const getCardType = (type, img) => {
  if (type) {
    if (type === 'DISCOVER') {
      if (img.indexOf('disc') !== -1) {
        return 'DISCOVER';
      }
      return 'DINERS';
    }
    return type;
  }
  return 'DEFAULT';
};

export default getCardType;
